import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

export const isCompanyAiSettingsResult = objectOf({
  generative_ai_kill_switch: boolean,
});
